export default {
  label: {
    size: {
      width: 'Width',
      height: 'Height'
    }
  },
  form: {
    title: 'Title',
    titlePlaceholder: 'Please enter title',
    subtitle: 'Subtitle',
    subtitlePlaceholder: 'Please enter sub title',
    content: 'Content',
    clickToJump: 'Hyperlink',
    internalPageOption: 'Internal Page',
    externalPageOption: 'External Web Page Link',
    externalPagePlaceholder: 'Input link',
    openInNewWindow: 'Open Link In New Tab',
    upload: 'Upload',
    yes: 'YES',
    no: 'NO',
    img: 'Image',
    video: 'Video',
    notSupportVideo: 'Your browser does not support HTML5 Video Tags.',
    uploadCanNotEmpty: 'Please upload an image or a video',
    linkCanNotEmpty: 'Please input a link',
    align: 'Align'
  },
  message: {
    saveSuccess: 'Save successfully',
    failedSave: 'Failed to save'
  },
  SIZE_TYPE: {
    AUTO: 'Auto',
    FIXED: 'Fixed',
    SCREEN_PERCENTAGE: 'Screen Percentage'
  }
}
